import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Logout from "./Logout";
import { authUserLogout } from "./AuthAction";

const mapStateToProps = (state, ownProps) => {
  return {
    payload: state.Auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      authUserLogout,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Logout);
